import avatarPreset1 from "./avatar-preset-1.png";
import avatarPreset2 from "./avatar-preset-2.png";

export const AVATAR_PRESETS = [
  { key: "preset-1", src: avatarPreset1, alt: "Friendly blob character" },
  { key: "preset-2", src: avatarPreset2, alt: "Friendly star character" },
] as const;
